import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDiscordServersQueryVariables = Types.Exact<{
  ownerUserId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  ownerTeamId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;

export type GetDiscordServersQuery = {
  __typename?: 'Query';
  discordServers: {
    __typename?: 'DiscordServerConnection';
    edges: Array<{
      __typename?: 'DiscordServerEdge';
      node: {
        __typename?: 'DiscordServer';
        id: any;
        name: string;
        createdAt: any;
        owner?:
          | { __typename?: 'Team'; id: any; name: string }
          | { __typename?: 'User'; id: any; email: string }
          | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export const GetDiscordServersDocument = gql`
  query GetDiscordServers($ownerUserId: UUID, $ownerTeamId: UUID) {
    discordServers(ownerUserId: $ownerUserId, ownerTeamId: $ownerTeamId) {
      edges {
        node {
          id
          owner {
            ... on User {
              id
              email
            }
            ... on Team {
              id
              name
            }
          }
          name
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetDiscordServersQuery__
 *
 * To run a query within a React component, call `useGetDiscordServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscordServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscordServersQuery({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *      ownerTeamId: // value for 'ownerTeamId'
 *   },
 * });
 */
export function useGetDiscordServersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDiscordServersQuery,
    GetDiscordServersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDiscordServersQuery,
    GetDiscordServersQueryVariables
  >(GetDiscordServersDocument, options);
}
export function useGetDiscordServersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDiscordServersQuery,
    GetDiscordServersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDiscordServersQuery,
    GetDiscordServersQueryVariables
  >(GetDiscordServersDocument, options);
}
export function useGetDiscordServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDiscordServersQuery,
        GetDiscordServersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDiscordServersQuery,
    GetDiscordServersQueryVariables
  >(GetDiscordServersDocument, options);
}
export type GetDiscordServersQueryHookResult = ReturnType<
  typeof useGetDiscordServersQuery
>;
export type GetDiscordServersLazyQueryHookResult = ReturnType<
  typeof useGetDiscordServersLazyQuery
>;
export type GetDiscordServersSuspenseQueryHookResult = ReturnType<
  typeof useGetDiscordServersSuspenseQuery
>;
export type GetDiscordServersQueryResult = Apollo.QueryResult<
  GetDiscordServersQuery,
  GetDiscordServersQueryVariables
>;
